export default "__VITE_ASSET__DpmuSrJK__"